import { render, staticRenderFns } from "./EditProjectIcon.vue?vue&type=template&id=07ac5a83"
import script from "./EditProjectIcon.vue?vue&type=script&lang=js"
export * from "./EditProjectIcon.vue?vue&type=script&lang=js"
import style0 from "./EditProjectIcon.vue?vue&type=style&index=0&id=07ac5a83&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports